export enum CollectionOverViewMetricsCardTypeEnum {
    WEEKLY_METRICS = 'weekly_metrics',
    PERSONAS = 'personas',
    EVENTS = 'events',
    TOP_PEOPLE = 'top_people',
    NEGATIVE_QUERIES = "negative_queries"
}

export enum OverviewTabNameEnum {
    OVERVIEW = 'Overview',
    CRM = 'CRM'
};

export enum CollectionPageModeEnum {
    OVERVIEW = "overview",
    CRM = "crm",
    CONTENT = "content",
    REPORT = "report",
    SETTINGS = "settings"
}

export enum CollectionThreeDotsMenuItemsEnum {
    SHARE_COLLECTION = 'Share Collection',
    COPY_URL = 'Copy URL',
    DELETE = 'Delete',
    CREATE_CONTENT = "Create Content",
    UPLOAD_CONTENT = "Upload Content",
    LINK_CONTENT = "Link Content"
}

export enum ContentThreeDotsMenuItemsEnum {
    COPY_URL = 'Copy URL',
    VIEW_SUMMARY = 'View summary',
    DOWNLOAD_DOCUMENT = 'Download content',
    DELETE_FROM_COLLECTION = 'Delete from collection',
    DELETE = 'Delete Content'
}

export enum DeleteModesEnum {
    DELETE_COLLECTION = 'delete_collection',
    DELETE_CONTENT = 'delete_content',
    DELETE_CONTENT_FROM_COLLECTION = 'delete_content_from_collection'
}

export enum CollectionListSectionEnum {
    ALL = "ALL",
    STARRED = "STARRED"
}

export enum CollectionReportPageEnum {
    KNOWLEDGE_GAPS = "knowledge-gaps",
    AGENT_PERFORMANCE = "agent-performance"
}

export enum AddContentStatusEnum {
    SUCCESS = 'success',
    ERROR = 'error'
}

export enum DocumentAddToCollectionStatusEnum {
    ADDING = "ADDING",
    ADDED = "ADDED",
    NOT_IN_COLLECTION = "NOT_IN_COLLECTION"
}